/************
 * Developed by : Shiva Software Solutions
 * Date : 08-08-2025
 * Descriptions : Digitization reducers
 ************/

import { 
    DISCH_PENDING_DATA, 
    DISCH_PENDING_COUNT, 
    DISCHARGE_SUMMARY_COUNTS,
    DISCH_INPROGRESS_COUNT,
    DISCH_INPROGRESS_DATA,
    DISCHARGE_SUMMARY,
    MRD_HEADER_MASTER,
    DISCHARGE_FILELIST,
    MRD_DETS,
    DISCH_COMPLETE_DATA,
    DISCH_COMPLETE_COUNT,
    DISCH_REJECT_DATA,
    DISCH_REJECT_COUNT,
    DISCH_TIMEDIFF_COUNT,
    DISCH_CLIENT_LIST,
    MRD_HEADER_MASTER_SAVE,
    SAVE_DISCHARGE_SUMMARY,
} from '../../shared/constants/ActionTypes';

const initialState = {
    dischargesummary_pending_data: [],
    dischargesummary_pending_count: 0,
    discharge_summary_counts:{},
    dischargesummary_inprogress_data: [],
    dischargesummary_inprogress_count: 0,
    discharge_summary: '',
    mrdHeaderMaster: [],
    mrdHeaderMasterSave: '',
    disFileList: '',
    mrdDetails: '',
    dischargesummary_complete_data: [],
    dischargesummary_complete_count: 0,
    dischargesummary_reject_data: [],
    dischargesummary_reject_count: 0,
    dischargesummary_timediff_count: 0,
    dischargesummary_client_list: [],
    savedischargestatus: '',
};

const dischargesummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case DISCH_PENDING_DATA:
            return {
                ...state,
                dischargesummary_pending_data: action.payload,
            };
        case DISCH_PENDING_COUNT:
            return {
                ...state,
                dischargesummary_pending_count: action.payload,
            };
        case DISCHARGE_SUMMARY_COUNTS:
            return {
                ...state,
                discharge_summary_counts: action.payload,
            };
        case DISCH_INPROGRESS_DATA:
            return {
                ...state,
                dischargesummary_inprogress_data: action.payload,
            };
        case DISCH_INPROGRESS_COUNT:
            return {
                ...state,
                dischargesummary_inprogress_count: action.payload,
            };
        case DISCHARGE_SUMMARY:
            return {
                ...state,
                discharge_summary : action.payload
            };
        case MRD_HEADER_MASTER:
            return {
                ...state,
                mrdHeaderMaster : action.payload
            };
        case MRD_HEADER_MASTER_SAVE:
            return {
                ...state,
                mrdHeaderMasterSave: action.payload,
            };
        case DISCHARGE_FILELIST:
            return {
                ...state,
                disFileList : action.payload
            };
        case MRD_DETS:
            return {
                ...state,
                mrdDetails : action.payload
            }; 
        case DISCH_COMPLETE_DATA:
            return {
                ...state,
                dischargesummary_complete_data : action.payload
            }; 
        case DISCH_COMPLETE_COUNT:
            return {
                ...state,
                dischargesummary_complete_count : action.payload
            }; 
        case DISCH_REJECT_DATA:
            return {
                ...state,
                dischargesummary_reject_data : action.payload
            }; 
        case DISCH_REJECT_COUNT:
            return {
                ...state,
                dischargesummary_reject_count : action.payload
            }; 
        case SAVE_DISCHARGE_SUMMARY:
            return {
                ...state,
                savedischargestatus : action.payload
            };    
        case DISCH_TIMEDIFF_COUNT:
            return {
                ...state,
                dischargesummary_timediff_count : action.payload
            };    
        case DISCH_CLIENT_LIST:
            return {
                ...state,
                dischargesummary_client_list : action.payload
            };    
        case DISCH_TIMEDIFF_COUNT:
            return {
                ...state,
                dischargesummary_timediff_count : action.payload
            };    
        case DISCH_CLIENT_LIST:
            return {
                ...state,
                dischargesummary_client_list : action.payload
            }; 
        default:
            return state;
    }
};

export default dischargesummaryReducer;